import React from "react"

class MoveFolioButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      success: null,
    }
    this.onAdd = this.onAdd.bind(this);
  }

  render(){
    let href = (this.href())
    return(
      <div className="add-charge-button">
        {this.renderSuccess()}
        <AddButton model="Folio" text={I18n.t('move_folio')} buttonClasses="btn btn-secondary " disabled={this.props.checkboxesChecked.length >= 1 && this.props.table_action.enabled == 'multiple' ? false : true} reservation_segment={this.props.reservation_segment} new_button={false} onAdd={this.onAdd} />
        <a ref="hiddenLink" data-nested="true" href={href} className="modal-iframe" style={{ display: 'none' }}></a>
      </div>
    );
  };

  renderSuccess() {
    if (this.state.success) {
      return <div className="alert-success">{this.state.success}</div>
    } else {
      return null;
    };
  };

  href(){
    return `/admin/folio-items/move?` + `&folio_items_ids=` + this.state.folio_items_ids + `&folio_id=` + this.state.folio_id
  }

  onAdd(json) {
    this.setState({ folio_id: json.id, folio_items_ids: this.props.checkedCheckboxIds},  () => {
      $(this.refs.hiddenLink).trigger('click');
    });
  }
}

export default MoveFolioButton